<ng-container *ngFor="let notif of notifications">
    <div class="d-flex gap-2 p-2 rounded justify-content-between align-items-center mb-2" [ngStyle]="{'background-color': notif.color || '#BEE6FC'}">
        <div class="d-flex flex-column gap-2">
            <span class="title">{{ notif.title }}</span>
            <div class="d-flex gap-2">
                <span>{{ notif.description }}
                    <strong class="font-bold">
                        <a [href]="notif.url_link" target="_blank" rel="noopener noreferrer" class="text-black text-decoration-none">
                            {{ notif.url_link }}
                        </a>
                    </strong>
                </span>
            </div>
        </div>
        <button class="btn" (click)="removeNotification(notif.id)" aria-label="Close notification">
            <img src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg" alt="close">
        </button>
    </div>
</ng-container>